import { cloudFunction } from '../parse';

export const fetchAllSupplier = async (data: Record<string, any>) => {
  return cloudFunction('fetchPaginatedSuppliers', data);
};

export const fetchSuppliersForDropDown = async (data?: Record<string, any>) => {
  return cloudFunction('fetchSuppliersForDropDown', data);
};

export const searchInventoryItemsForSupplier = (supplierId: string, term?: string, page?: number, limit?: number) => {
  return cloudFunction('searchInventoryItemsForSupplier', { supplierId, term, page, limit });
};

export const createPurchaseOrder = (data: Record<string, any>) => {
  return cloudFunction('createPurchaseOrder', data);
};

export const updatePurchaseOrder = (data: Record<string, any>) => {
  return cloudFunction('updatePurchaseOrder', data);
};

export const fetchPurchaseOrders = (filterData: Record<string, any>) => {
  return cloudFunction('fetchPurchaseOrders', filterData);
};

export const fetchPurchaseOrderDetail = async (id: string) => {
  const res = await cloudFunction('fetchPurchaseOrderDetail', { id });

  res.purchaseOrderItems = res.purchaseOrderItems.map(item => {
    return {
      ...item,
      editable: false,
    };
  });

  return res;
};

export const adjustReceivedQuantity = (id: string, quantity: number) => {
  return cloudFunction('adjustReceivedQuantity', { id, quantity });
};

export const adjustProducerFulfilledQuantity = (id: string, quantity: number) => {
  return cloudFunction('adjustProducerFulfilledQuantity', { id, quantity });
};

export const correctProducerReceivedQuantity = (id: string, quantity: number) => {
  return cloudFunction('correctProducerReceivedQuantity', { id, quantity });
};

export const adjustPOItemPrice = (id: string, price: number) => {
  return cloudFunction('adjustPOItemPrice', { id, price });
};

export const editPOItemDetails = (params: { 
  id: string; price?: number; cost?: number; producerReceivedQuantity: number; receivedQuantity: number; 
}) => {
  return cloudFunction('editPOItemDetails', params);
};

export const sendPurchaseOrderToSupplier = (id: string) => {
  return cloudFunction('sendPurchaseOrderToSupplier', { id });
};

export const fulfillPurchaseOrder = (id: string) => {
  return cloudFunction('fulfillPurchaseOrder', { id });
};

export const cancelPurchaseOrder = (id: string) => {
  return cloudFunction('cancelPurchaseOrder', { id });
};

export const deletePurchaseOrder = (id: string) => {
  return cloudFunction('deletePurchaseOrder', { id });
};

export const uploadInvoiceForPurchaseOrder = (data: Record<string, any>) => {
  return cloudFunction('uploadInvoiceForPurchaseOrder', data);
};

export const deleteInvoiceForPurchaseOrder = (id: string) => {
  return cloudFunction('deleteInvoiceForPurchaseOrder', { id });
};

export const reopenPurchaseOrder = (id: string) => {
  return cloudFunction('reopenPurchaseOrder', { id });
};

export const revertPOItemQuantityChanges = (id: string) => {
  return cloudFunction('revertPOItemQuantityChanges', { id });
};

export const applyPOItemQuantityChanges = (id: string) => {
  return cloudFunction('applyPOItemQuantityChanges', { id });
};

export const removePOItemFromPurchaseOrder = (poItemId: string) => {
  return cloudFunction('removePOItemFromPurchaseOrder', { poItemId });
};

export const addInventoryItemsToPurchaseOrder = (params: any) => {
  return cloudFunction('addInventoryItemsToPurchaseOrder', params);
};
